
























































































































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { mapGetters, mapState } from 'vuex';

import { Quiz, User } from 'frontend/types';
import LessonButton from 'frontend/views/courses/CoursePage/components/LessonButton.vue';
import ProgressBar from 'frontend/views/courses/CoursePage/components/ProgressBar.vue';
import { buildPremiumRedirect } from 'frontend/utils/premium-redirect';
import LessonAdmin from 'frontend/views/courses/CoursePage/components/LessonAdmin.vue';
import { safeWindow } from 'frontend/utils/window';
import { RawLocation } from 'vue-router/types/router';
import { RelatedLearningPathInfo } from 'frontend/types/learningPathV2';

@Component({
  components: {
    ProgressBar,
    LessonButton,
    LessonAdmin,
  },
  computed: {
    ...mapState('globals', ['user']),
    ...mapGetters('pageHeader', ['isMobile']),
    ...mapGetters('response', ['requestPath']),
    ...mapGetters('paywall', ['showMathFoundationPlan']),
    ...mapGetters('relatedLearningPathInfo', ['learningPath']),
  },
})
export default class Lesson extends Vue {
  @Prop({ type: Object, required: true })
  private lesson!: Quiz;
  @Prop({ type: Number, required: true })
  private courseId!: number;
  @Prop({ type: Boolean, required: true })
  private isLocked!: boolean;
  @Prop({ type: Boolean, required: true })
  private isRecommended!: boolean;
  @Prop({ type: Boolean, default: false })
  private isLast!: boolean;
  @Prop({ type: String, required: true })
  private courseName!: string;

  private readonly learningPath?: RelatedLearningPathInfo;
  private readonly user!: User;
  private readonly requestPath!: string;
  private showMathFoundationPlan!: boolean;

  private get hasPractice(): boolean {
    return !!this.lesson.practice_lessons.length;
  }

  private get completionPercentage(): number {
    if (this.lesson.user_activity.total) {
      return this.lesson.user_activity.num_complete / this.lesson.user_activity.total;
    }
    return 0;
  }

  private lessonLinkWithLLP = (
    url: string,
    learningPath?: RelatedLearningPathInfo,
  ): RawLocation => {
    if (learningPath) {
      return { path: url, query: { from_llp: learningPath.slug } };
    }
    return { path: url };
  };

  private preventIfLocked(event: Event): void {
    if (!this.user.is_authenticated || this.isLocked) {
      event.preventDefault();
      this.preventAccess();
    }
  }

  private get inTieredPlanExperiment(): boolean {
    return this.showMathFoundationPlan;
  }

  private preventAccess(): void {
    if (!this.user.is_authenticated) {
      safeWindow()?.sessionStorage.setItem('icp_signup', this.$route.path);
      this.$store.dispatch('signupModal/signup');
    } else if (this.isLocked) {
      const premiumRedirect = buildPremiumRedirect({
        user: this.user,
        requestPath: this.requestPath,
        axId: 'clicked_b2_course_landing_locked_quiz',
        targetObjectId: this.lesson.quiz_id,
        targetObjectType: 'quiz',
        targetObjectReferrer: this.$route.path,
        inTieredPlanExperiment: this.inTieredPlanExperiment && this.user.subscription_tier !== null,
      });
      this.$router.push(premiumRedirect);
    }
  }
}
